// extracted by mini-css-extract-plugin
module.exports = {"root":"NavCard_root__CTTMy","main":"NavCard_main__eETZq","title":"NavCard_title__DEmse","imageBox":"NavCard_imageBox__Llc6e","rotation":"NavCard_rotation__PHDqk"};